import {SlctOption} from 'module/Slct/type/SlctType'
import {CFInputCSS} from 'module/CustomField/style/cssCFInput'

interface Args {
	disabled: undefined | boolean
	valueObj: SlctOption<any, any> | null
	value: string | number | undefined | null
	focus: boolean
}

export function getSlctColor(args: Args) {
	let {disabled, valueObj, value, focus} = args
	let background: string = disabled ? CFInputCSS.disabled.background : CFInputCSS.background
	let color: string = disabled ? CFInputCSS.disabled.color : CFInputCSS.color
	if (valueObj && value && !focus) {
		background = valueObj.valuebackground || valueObj.background || background
		color = valueObj.valuecolor || valueObj?.color || color
	}
	return {background, color}
}